module.exports = __webpack_public_path__ + "static/media/login-bg@2x.1001b69e.png";